<template>
  <!-- SITE NAVIGATION -->
  <div class="bg-alt no-print">
    <div class="container position-relative">
      <!-- SITE NAV DESKTOP -->
      <div id="site-nav" class="site-nav">
        <header class="header row my-2">
          <div class="col">
            <h1>{{ $t('org.imLookingForResearchAbout') }}</h1>
          </div>
          <div class="col-auto">
            <button id="global-nav-toggle" class="btn btn--clean">
              Menu <i class="fas fa-bars ml-2"></i>
            </button>
          </div>
        </header>
        <div class="row align-items-stretch pb-3">
          <div
            class="col field"
            :class="showMobileInput ? 'keyword-search-field-mobile' : 'keyword-search-field'"
          >
            <input
              type="text"
              placeholder="Keyword e.g. cancer, drug name"
              class="input autocomplete__input"
            />
            <i class="field__icon fa fa-search"></i>
          </div>
          <div class="col d-none d-lg-block field">
            <input type="text" placeholder="Location e.g. city, postcode" class="input" />
            <i class="field__icon fas fa-map-marker-alt"></i>
          </div>
          <div class="align-items-center col-auto d-none d-lg-flex">
            <button class="btn btn--nav" onclick="javascript:goToResults()">
              Search for study
            </button>
            <span class="font-weight-bold mx-2">or</span>
            <button class="btn btn--nav">View conditions</button>
          </div>
        </div>
      </div>
      <!-- DROPDOWN NAV -->
      <div id="global-nav" class="d-none global-nav">
        <header class="header row">
          <div class="col">
            <h1>Menu</h1>
          </div>
          <div class="col-auto">
            <button class="btn btn--close" data-target="#global-nav">
              <i class="fa fa-times-circle"></i>
            </button>
          </div>
        </header>
        <div class="row">
          <div class="col">
            <ul class="nav-vertical p-lg-2">
              <!-- Home -->
              <li class="nav-vertical__item nav-vertical__item--active">
                <a href="" class="nav-vertical__content">Home</a>
              </li>
              <!-- Taking Part -->
              <li class="nav-vertical__item">
                <a href="" class="nav-vertical__content">Taking Part</a>
                <button class="btn btn--clean nav-vertical__expand">
                  <i class="fa fa-chevron-down"></i>
                </button>
              </li>
              <ul class="nav-vertical nav-vertical--nested">
                <li class="nav-vertical__item">
                  <a href="" class="nav-vertical__content">Why take part</a>
                </li>
                <li class="nav-vertical__item">
                  <a href="" class="nav-vertical__content">What happens on a study</a>
                </li>
                <li class="nav-vertical__item">
                  <a href="" class="nav-vertical__content">How to take part</a>
                </li>
                <li class="nav-vertical__item">
                  <a href="" class="nav-vertical__content">Volunteering without a condition</a>
                </li>
                <li class="nav-vertical__item">
                  <a href="" class="nav-vertical__content">Other ways to get involved</a>
                </li>
                <li class="nav-vertical__item">
                  <a href="" class="nav-vertical__content">UK registries</a>
                </li>
              </ul>
              <!-- Promote Research -->
              <li class="nav-vertical__item">
                <a href="" class="nav-vertical__content">Promote Research</a>
                <button class="btn btn--clean nav-vertical__expand">
                  <i class="fa fa-chevron-down"></i>
                </button>
              </li>
              <li class="nav-vertical__item">
                <a href="" class="nav-vertical__content">News</a>
                <button class="btn btn--clean nav-vertical__expand">
                  <i class="fa fa-chevron-down"></i>
                </button>
              </li>
              <li class="nav-vertical__item">
                <a href="" class="nav-vertical__content">About</a>
                <button class="btn btn--clean nav-vertical__expand">
                  <i class="fa fa-chevron-down"></i>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { MOBILE_WIDTH } from '@/utilities/constants'

export default {
  data: () => ({ screenWidth: window?.innerWidth || 0 }),
  computed: {
    isMobile() {
      return this.screenWidth <= MOBILE_WIDTH
    },
    showMobileInput() {
      return this.isMobile
    },
  },
  created() {
    window.addEventListener('resize', this.updateWidth)
  },
  destroyed() {
    window.removeEventListener('resize', this.updateWidth)
  },
  methods: {
    updateWidth() {
      this.screenWidth = window.innerWidth
    },
  },
}
</script>
